/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Announcements_No_DetailsInputs */

const fr_announcements_no_details = /** @type {(inputs: Announcements_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette actualité ne contient pas de détails.`)
};

const en_announcements_no_details = /** @type {(inputs: Announcements_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This news item has no details.`)
};

/**
* | output |
* | --- |
* | "This news item has no details." |
*
* @param {Announcements_No_DetailsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const announcements_no_details = /** @type {((inputs?: Announcements_No_DetailsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcements_No_DetailsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_announcements_no_details(inputs)
	return en_announcements_no_details(inputs)
});